module.exports = __webpack_public_path__ + "static/media/traffic-alert.b789c2f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/traffic-alert.svg
// module id = 423
// module chunks = 0